<ng-template #inputBox let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ title }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('X click')"></button>
  </div>
  <form [formGroup]="inputForm" (ngSubmit)="onSubmit()">
    <div class="modal-body">
      <div class="form-group">
        <label for="input-text">{{ prompt }}</label>
        <input type="text" id="input-text" formControlName="inputText" class="form-control" [attr.maxlength]="maxLength" ngbAutofocus [class.is-invalid]="inputText.invalid && inputText.touched" oninput="this.value = this.value.toUpperCase()" />
        @if (inputText.touched && inputText.hasError('required')) {
          <small class="text-danger">A value is required</small>
        }
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-primary" [disabled]="!inputForm.valid">{{ acceptButtonCaption }}</button>
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">{{ cancelButtonCaption }}</button>
    </div>
  </form>
</ng-template>
